import { useQuery } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";

export type GlobalTransformation = {
  id: string;
  matrix: number[][];
  createdBy: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
  projectId: string;
  name: string;
  proj4_string: string;
};

type UniscanCalculatedTransformation = {
  scanWrtWorld: number[][];
  errors: any[];
};

export const useGetScanTransformationQuery = (scanId: string) => {
  const { authApi } = useAuth();
  const result = useQuery({
    queryKey: ["scan-transform-wrt-world", scanId],
    queryFn: async () => {
      if (scanId === "") {
        return null;
      }
      const { data } = await authApi.get<UniscanCalculatedTransformation>(
        `/scan/${scanId}/transform`
      );
      return data;
    },
  });

  return result;
};